module.exports = __webpack_public_path__ + "media/images/badges/akt/milestone-2-Inactive-AKT-26a435aee3d85be73657119302c9e82c.png";